import { TicketsPeriodPreset, TicketsView } from "hooks/useTicketsQueryParams";

export interface TicketsHrefParams {
  view?: TicketsView;
  branchID?: string | null;
  trainNumber?: string | null;
  categoryID?: string | null;
  type?: string;
  period?: TicketsPeriodPreset;
  from?: string;
  to?: string;
}

// Превращает date-like строку в YYYY-MM-DD (формат, который ожидает <input type="date">
// и который понимает бэкенд resolveListPeriod через moment).
export const toDateOnly = (value: string | undefined | null): string => {
  if (!value) return "";
  return String(value).slice(0, 10);
};

// Последний день месяца для period вида "YYYY-MM" — нужен для перехода с месячного бара.
export const endOfMonthDate = (period: string): string => {
  const [yStr, mStr] = period.split("-");
  const y = Number(yStr);
  const m = Number(mStr);
  if (!y || !m) return "";
  const last = new Date(y, m, 0).getDate();
  return `${period}-${String(last).padStart(2, "0")}`;
};

export const startOfMonthDate = (period: string): string => `${period}-01`;

// Собирает /admin/tickets URL с queryparams совместимыми с useTicketsQueryParams.
// Любые from/to автоматически переведут страницу в period=custom (так FilterBar показывает
// нужные виджеты), если period явно не задан.
export const buildTicketsHref = (params: TicketsHrefParams): string => {
  const sp = new URLSearchParams();
  const { view, branchID, trainNumber, categoryID, type, from, to } = params;
  let { period } = params;

  if ((from || to) && !period) period = "custom";

  if (view && view !== "kanban") sp.set("view", view);
  if (branchID) sp.set("branchID", branchID);
  if (trainNumber) sp.set("trainNumber", trainNumber);
  if (categoryID) sp.set("categoryID", categoryID);
  if (type) sp.set("type", type);
  if (period && period !== "all") sp.set("period", period);
  if (from) sp.set("from", from);
  if (to) sp.set("to", to);

  const qs = sp.toString();
  return qs ? `/admin/tickets?${qs}` : "/admin/tickets";
};
